import styled from 'styled-components'

import { IconButton } from '@material-ui/core'

export const ClearButton = styled(IconButton)`
  position: absolute !important;
  margin-left: -40px !important;
`
